import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAuthState, IUser } from '@/domain/auth/interfaces/auth.interface'
import { setUserContext, clearUserContext } from '@/config/sentry.config'

const initialState: IAuthState = {
  accessToken: null,
  refreshToken: null,
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        accessToken: string
        refreshToken: string
        user: IUser
      }>
    ) => {
      state.accessToken = action.payload.accessToken
      state.refreshToken = action.payload.refreshToken
      state.user = action.payload.user
      state.isAuthenticated = true
      state.error = null

      // Set user context in Sentry
      setUserContext({
        id: action.payload.user.uuid,
        email: action.payload.user.email,
        username: action.payload.user.username
      })
    },
    logout: (state) => {
      state.accessToken = null
      state.refreshToken = null
      state.user = null
      state.isAuthenticated = false
      state.error = null

      // Clear user context in Sentry
      clearUserContext()
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    }
  }
})

export const { login, logout, setError, setLoading } = authSlice.actions
export default authSlice.reducer
